<template>
    <el-input
              :type="types"
              :inputmode="'numeric'"
              placeholder="+新增"
              :maxlength="8"
              v-model="vModel"
              class="no-border e-invoice tax-id-input"/>
</template>

<script>
    export default {
        name: "TaxIdNumber",
        props: ["value"],
        data() {
            return {
                vModel: this.value,
                types: 'password',
            }
        },
        created() {

        },
        mounted() {
            //android鍵盤需要先改成密碼鍵盤，才會只有單純數字沒符號的鍵盤
            this.types='text'
        },
        methods: {
        },
        watch:{
            vModel: {
              handler:function (newVal,oldVal) {
                this.$emit('update',newVal);
              },
              deep : true ,
              immediate : true,
            },
        },
    }
</script>
